export default __webpack_public_path__ + "static/media/ambient-bright-red.d754ace1.jpg";